/// <reference path="../components/footer/footer.tsx" />
/// <reference path="../components/footer/footer.tsx" />
import { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import SvgIcons from "../components/re-usable/icons/svg-icons";
import { useAppDispatch } from "../redux/store";
import { retrieveNotification } from "../redux/slice/notification-slice";
import LoadingComp from "../components/re-usable/loading/loading";
import EuropeRouter from "../routes/europe-2024-routes";
import EuropeHeader from "../components/header/europe-2024-header";
import EuropeLayoutStyleComponent from "./components/europe-2024-layout-style.component";
import Convergence2023Footer from "../components/footer/convergence-2023-footer";
import Footer from "../components/footer/footer";

const Layout = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(retrieveNotification())
  })
  return (
    <>
      <EuropeLayoutStyleComponent />
      <div>
        <EuropeHeader />
        <Suspense fallback={<LoadingComp />}>
          <Routes>
            {EuropeRouter.map((route, index) => {
              return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
            })}
          </Routes>
        </Suspense>
        {/*<Convergence2023Footer footerClass=" bg-primary text-light mt-4" />*/}
        <Footer />
      </div >
    </>
  );
};

export default Layout;